"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addProfessionalLink = exports.getContactsWithoutLinkedin = exports.typeaheadSearch = exports.getClientPositionSuggestions = exports.handlePasswordReset = exports.getClientProjectCount = exports.getClientProjects = exports.getClientContacts = exports.searchClients = exports.getClientContact = exports.deleteClientContact = exports.updateClientContact = exports.createClientContact = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
function createClientContact(contactData) {
    return api_1.default.post('/api/client', contactData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.createClientContact = createClientContact;
function updateClientContact(contactId, contactData) {
    return api_1.default.put("/api/client/".concat(contactId), contactData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateClientContact = updateClientContact;
function deleteClientContact(contactId) {
    return api_1.default.delete("/api/client/".concat(contactId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.deleteClientContact = deleteClientContact;
function getClientContact(contactId) {
    return api_1.default
        .get('/api/client/' + contactId)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getClientContact = getClientContact;
function searchClients(data) {
    return api_1.default
        .post(process.env.REACT_APP_SEARCH_SERVICE_URL + '/client', tslib_1.__assign(tslib_1.__assign({}, data), { country: data.country || undefined }))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.searchClients = searchClients;
function getClientContacts(query) {
    var queryParams = query_string_1.default.stringify(query);
    return api_1.default.get("/api/client?".concat(queryParams)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getClientContacts = getClientContacts;
function getClientProjects(contactId, page) {
    return api_1.default.get("/api/client/projects/".concat(contactId, "?limit=10&page=").concat(page)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getClientProjects = getClientProjects;
function getClientProjectCount(contactId) {
    return api_1.default
        .get('/api/client/' + contactId + '/project-count')
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getClientProjectCount = getClientProjectCount;
function handlePasswordReset(clientEmail) {
    return api_1.default.post('/api/forgot-password', {
        email: clientEmail,
    });
}
exports.handlePasswordReset = handlePasswordReset;
function getClientPositionSuggestions(positionString) {
    return api_1.default.get("/api/client/positions?q=".concat(positionString)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getClientPositionSuggestions = getClientPositionSuggestions;
function typeaheadSearch(parentAccountId, query, active) {
    var queryParams = query_string_1.default.stringify({
        parentAccountId: parentAccountId,
        q: query,
        active: active,
    });
    return api_1.default.get("/api/client/typeahead-search?".concat(queryParams)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.typeaheadSearch = typeaheadSearch;
function getContactsWithoutLinkedin(page) {
    return api_1.default.get("/api/client/without-linkedin?page=".concat(page)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getContactsWithoutLinkedin = getContactsWithoutLinkedin;
function addProfessionalLink(id, professionalLinkUrl) {
    return api_1.default
        .post("/api/client/".concat(id, "/add-professional-link"), { professionalLinkUrl: professionalLinkUrl })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.addProfessionalLink = addProfessionalLink;
var api = {
    createClientContact: createClientContact,
    updateClientContact: updateClientContact,
    deleteClientContact: deleteClientContact,
    getClientContact: getClientContact,
    getContactsWithoutLinkedin: getContactsWithoutLinkedin,
    getClientContacts: getClientContacts,
    searchClients: searchClients,
    getClientProjects: getClientProjects,
    getClientProjectCount: getClientProjectCount,
    handlePasswordReset: handlePasswordReset,
    getClientPositionSuggestions: getClientPositionSuggestions,
    typeaheadSearch: typeaheadSearch,
};
exports.default = api;
